<template>
    <span v-if="isToday"
          data-component="TodayBadge"
          class="label label-info">
        {{ l('TODAY') }}
    </span>
    <span v-else-if="showNotToday && isNotToday"
          data-component="TodayBadge"
          class="label label-warning">
        {{ l('NOT_TODAY') }}
    </span>
</template>

<script>
const { isSameDay } = require('@/functions/date');

export default {
    name: 'TodayBadge',

    props: {
        // A Date object, or anything the Date constructor can parse (e.g. an ISO string).
        // Only the calendar date is considered - time of day is ignored.
        date: {
            type: [String, Date],
            default: null,
        },
        showNotToday: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        parsedDate() {
            if (!this.date) {
                return null;
            }

            const inputDate = this.date instanceof Date ? this.date : new Date(this.date);

            return Number.isNaN(inputDate.getTime()) ? null : inputDate;
        },

        isToday() {
            return !!this.parsedDate && isSameDay(new Date(), this.parsedDate);
        },

        /**
         * Not quite the inverse of isToday because it will also return false for an invalid date.
         *
         * @return {boolean}
         */
        isNotToday() {
            return !!this.parsedDate && !this.isToday;
        },
    },
};
</script>
